import React, {ReactElement, ReactNode} from "react";
import styles from "./Suggestions.module.scss";

interface Props {
    suggestions: string[];
    onClick: (suggestion: string) => void;
}

export const Suggestions = ({suggestions, onClick}: Props): ReactElement<ReactNode> => {
    if (suggestions.length === 0) {
        return <></>;
    }
    return (
        <div id="suggestions" className={styles.suggestions}>
            {suggestions.map((suggestion, index) => (
                <span id={`suggestions__button-${index}`} key={index} className={styles.suggestions__button} onClick={() => onClick(suggestion)}>
                    {suggestion}
                </span>
            ))}
        </div>
    )
}